import { useState, useEffect, useRef } from 'react';
import { eliminarCookies } from '../../../utils/helpers';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _FunctionalArea, _single, _SystemPropertyOB } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
  login: boolean;
  setIsLogged: Function;
}

const SessionTimeout = ({ login, setIsLogged }: Props) => {
  const { instance } = useDataBean(_SystemPropertyOB);
  const _functionalArea = useDataBean(_FunctionalArea);

  const [sessionDuration, setSessionDuration] = useState(60 * 5);
  const [timeRemaining, setTimeRemaining] = useState(60 * 5);

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    instance.getSystemProperty("time_session").then(resp => {
      const minutos = parseInt(resp.SystemValue || "5");
      const segundos = minutos * 60;
      setSessionDuration(segundos);
      setTimeRemaining(segundos);
      _single.setSessionItem('sessionStartTime', Math.floor(Date.now() / 1000).toString());
    }).catch(err => console.error(err));

    instance.getSystemProperty("Money_Locales").then(resp => {
      if (resp.SystemValue) _single.settMoneyFormater(resp.SystemValue);
    }).catch(err => console.error(err));

    instance.getSystemProperty("MODIFY_UBL_IMPORT").then(resp => {
      if (resp.SystemValue) _single.setSessionItem("canModifiUBL", resp.SystemValue);
    }).catch(err => console.error(err));

    if (_single.getAccountID()) {
      _functionalArea.instance.getFunctionalAreaByIDAccount(_single.getAccountID())
        .then(resp => _single.setIDLnFunctionalArea(resp))
        .catch(err => console.error(err));

      _functionalArea.instance.getFunctionalIDWorkMenber(_single.getAccountID())
        .then(resp => _single.setGroupOnMember(resp))
        .catch(err => console.error(err));
    }
  }, []);

  useEffect(() => {
    if (!login) return;
    intervalRef.current = setInterval(() => {
      const sessionStartTime = _single.getSessionItem('sessionStartTime');
      const now = Math.floor(Date.now() / 1000);
      const start = sessionStartTime ? parseInt(sessionStartTime) : now;
      const elapsed = now - start;
      const remaining = sessionDuration - elapsed;
      setTimeRemaining(remaining);
      if (remaining <= 0) closeSession();
    }, 1000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [login, sessionDuration]);

  useEffect(() => {
    const resetSession = () => {
      _single.setSessionItem('sessionStartTime', Math.floor(Date.now() / 1000).toString());
      setTimeRemaining(sessionDuration);
    };
    const events = ['mousemove', 'click', 'keypress', 'touchmove'];
    events.forEach(evt => window.addEventListener(evt, resetSession));
    return () => events.forEach(evt => window.removeEventListener(evt, resetSession));
  }, [sessionDuration]);

  useEffect(() => {
    const handleVisibility = () => {
      const sessionStartTime = _single.getSessionItem('sessionStartTime');
      const now = Math.floor(Date.now() / 1000);
      const start = sessionStartTime ? parseInt(sessionStartTime) : now;
      const elapsed = now - start;
      if (elapsed >= sessionDuration) closeSession();
      else setTimeRemaining(sessionDuration - elapsed);
    };
    window.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', handleVisibility);
    return () => {
      window.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleVisibility);
    };
  }, [sessionDuration]);

  const closeSession = () => {
    sessionStorage.clear();
    eliminarCookies();
    setIsLogged(false);
    window.location.reload();
  };

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <>
      {login && timeRemaining < 45 && timeRemaining > 0 && (
        <div className="fixed-top" style={{ marginTop: '5%' }}>
          <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="col-md-6">
              <div className="alert alert-warning text-center" role="alert">
                <p>
                  <strong>Su sesión está pronta a finalizar</strong> <br />
                  Tiempo restante: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionTimeout;
